var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#71C2FF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#444B54;}\n\t.st3{fill:none;stroke:#444B54;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#E4E4E7;}\n\t.st5{fill:#8CE5C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    className: "st1",
    width: 80,
    height: 80
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124,32c-1.7,0-3-1.3-3-3V14c0-3.9-3.1-7-7-7H99c-1.7,0-3-1.3-3-3s1.3-3,3-3h15c7.2,0,13,5.8,13,13v15 C127,30.7,125.7,32,124,32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4,32c-1.7,0-3-1.3-3-3V14C1,6.8,6.8,1,14,1h15c1.7,0,3,1.3,3,3s-1.3,3-3,3H14c-3.9,0-7,3.1-7,7v15 C7,30.7,5.7,32,4,32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,127H14c-7.2,0-13-5.8-13-13V99c0-1.7,1.3-3,3-3s3,1.3,3,3v15c0,3.9,3.1,7,7,7h15c1.7,0,3,1.3,3,3 S30.7,127,29,127z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114,127H99c-1.7,0-3-1.3-3-3s1.3-3,3-3h15c3.9,0,7-3.1,7-7V99c0-1.7,1.3-3,3-3s3,1.3,3,3v15 C127,121.2,121.2,127,114,127z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,107H84c-1.7,0-3-1.3-3-3V84c0-1.7,1.3-3,3-3h20c1.7,0,3,1.3,3,3v20C107,105.7,105.7,107,104,107z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,107c-1.7,0-3-1.3-3-3V94c0-1.7,1.3-3,3-3h9V74c0-1.7,1.3-3,3-3s3,1.3,3,3v20c0,1.7-1.3,3-3,3h-9v7 C61,105.7,59.7,107,58,107z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,47H84c-1.7,0-3-1.3-3-3V24c0-1.7,1.3-3,3-3h20c1.7,0,3,1.3,3,3v20C107,45.7,105.7,47,104,47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,47H24c-1.7,0-3-1.3-3-3V24c0-1.7,1.3-3,3-3h20c1.7,0,3,1.3,3,3v20C47,45.7,45.7,47,44,47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,67h-5c-1.7,0-3-1.3-3-3s1.3-3,3-3h5c1.7,0,3,1.3,3,3S30.7,67,29,67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,67h-9c-1.7,0-3-1.3-3-3s1.3-3,3-3h6V44c0-1.7,1.3-3,3-3h9V24c0-1.7,1.3-3,3-3s3,1.3,3,3v20 c0,1.7-1.3,3-3,3h-9v17C61,65.7,59.7,67,58,67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,73H91c-1.7,0-3-1.3-3-3v-9h-9c-1.7,0-3-1.3-3-3s1.3-3,3-3h12c1.7,0,3,1.3,3,3v9h10c1.7,0,3,1.3,3,3 S105.7,73,104,73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,107H24c-1.7,0-3-1.3-3-3V84c0-1.7,1.3-3,3-3h20c1.7,0,3,1.3,3,3v20C47,105.7,45.7,107,44,107z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.8129110713832c09d5e3bcf9c9755752.svg";
export { ForwardRef as ReactComponent };